import React from "react"
import CircularProgress from "material-ui/CircularProgress"
import Paper from "material-ui/Paper"
import Dialog from "material-ui/Dialog"
import FloatingActionButton from "material-ui/FloatingActionButton"
import ContentAdd from "material-ui/svg-icons/content/add"
import FlatButton from "material-ui/FlatButton"
import Table from "material-ui/Table"
import TableHeader from "material-ui/Table/TableHeader"
import TableHeaderColumn from "material-ui/Table/TableHeaderColumn"
import TableRow from "material-ui/Table/TableRow"
import TableRowColumn from "material-ui/Table/TableRowColumn"
import TableBody from "material-ui/Table/TableBody"
import TF from "material-ui/Table/TableFooter"
import TableFooter from "../../../components/layout/TableFooter"
import TableActionBar from "../../../components/layout/TableActionBar"
import AuthenticationStore from "../../../stores/AuthenticationStore"
import AccountStore from "../../../stores/AccountStore"
import HierarchySettingsStore from "../../../stores/HierarchySettingsStore"
import strings from "../../../localization/strings"
import { AutoComplete } from "material-ui"
import autobind from "class-autobind"
import * as accountActions from "../../../actions/AccountActions"
import * as hierarchyHelper from "../../../helpers/hierarchyHelper"
import { IUserDocument } from "../../../models"
interface IUser {
	Id?: string
	Name?: string
}
interface IProps {
	hierarchyItem: any
	readonly: boolean
}
interface IState {
	allUsersList: IUserDocument[]
	autoCompleteNames: IUser[]
	users: IUserDocument[]
	selectedUserKeys: number[]
	selectedUsers: IUserDocument[]
	filteredUsers: IUserDocument[]
	total: number
	offset: number
	limit: number
	limitOptions: number[]
	userTableRowSelectedCount: number
	showDeleteConfirm: boolean
	showAddUser: boolean
	loading: boolean
	selectedAutoCompleteUser: IUser
	allowUsers: boolean
	deleteTitle?: string
	deleteBody?: string
	disableButtons: boolean
}
const styles = {
	columnValue: {
		cursor: "pointer"
	}
}

export default class HierarchyUsers extends React.Component<IProps, IState> {
	private hUserAutocomplete
	constructor(props) {
		super(props)
		this.state = {
			allUsersList: [],
			autoCompleteNames: [],
			users: [],
			selectedUserKeys: [],
			filteredUsers: [],
			total: 0,
			offset: 0,
			limit: 200,
			limitOptions: [50, 100, 200],
			userTableRowSelectedCount: 0,
			showDeleteConfirm: false,
			showAddUser: false,
			loading: false,
			selectedAutoCompleteUser: {},
			allowUsers: false,
			selectedUsers: [],
			disableButtons: false,
		}
		autobind(this)
	}

	componentDidMount() {
		AccountStore.on("change", this.changeEvent)
		HierarchySettingsStore.on("global_change", this.hierarchyChangeEvent)
		this.getUsers()
		this.changeEvent()
	}

	hierarchyChangeEvent() {
		this.getUsers()
	}

	getUsers() {
		this.setState({ loading: true }, () => {
			accountActions.getAccountUsers(AuthenticationStore.getCookieAccountId())
		})
	}

	changeEvent() {
		if (!AccountStore.getCurrentAccount()) return
		let allowUsers = false
		if (this.props.hierarchyItem && !this.props.hierarchyItem.Id) {
			allowUsers = true
		} else {
			const hierarchyDefinition = AccountStore.getCurrentAccount().HierarchyDefinitions.find((item) => item.Id === this.props.hierarchyItem.HierarchyDefinitionId)
			allowUsers = hierarchyDefinition.EnableAccountUsers
		}
		this.setState({ allowUsers, users: [], filteredUsers: [], total: 0 }, () => {
			const currentAccount = AccountStore.getCurrentAccount() || {}
			let hierarchyLevel = this.props.hierarchyItem
			const allUsers = AccountStore.getUsers()
			let users
			if (!hierarchyLevel.Id) hierarchyLevel = currentAccount
			if (hierarchyLevel.LinkedUserIds) {
				users = allUsers.filter((u) => {
					return hierarchyLevel.LinkedUserIds.find((x) => x === u.Id)
				})
			} else {
				users = []
			}
			this.setState(
				{
					allUsersList: allUsers,
					users: users,
					filteredUsers: users,
					total: users.length,
					selectedUserKeys: [],
					selectedUsers: [],
					userTableRowSelectedCount: 0,
					selectedAutoCompleteUser: null,
					loading: false
				},
				() => {
					this.setUserForAutoComplete()
				}
			)
		})
	}
	componentWillUnmount() {
		AccountStore.removeListener("change", this.changeEvent)
		HierarchySettingsStore.removeListener("global_change", this.hierarchyChangeEvent)
	}

	setUserForAutoComplete() {
		const { allUsersList, users } = this.state
		const autoCompleteNames = []
		allUsersList &&
			allUsersList.length > 0 &&
			allUsersList.forEach((user) => {
				if (users.indexOf(users.find((item) => item.Id === user.Id)) > -1) return
				const obj = {} as IUser
				const lastName = user.LastName ? user.LastName : null
				const externalId = user.ExternalId ? user.ExternalId : null
				obj.Name = user.FirstName
				if (lastName) obj.Name += " " + lastName
				if (externalId) obj.Name += " - " + externalId
				obj.Id = user.Id
				autoCompleteNames.push(obj)
			})
		this.setState({ autoCompleteNames })
	}

	getLevelName(levelId) {
		return hierarchyHelper.getFullyQualifiedLevelNameById(levelId)
	}

	getSelectedUserKeys(users) {
		const selectedUserKeys = []
		users.forEach((user, index) => {
			if (user.selected) {
				selectedUserKeys.push(index)
			}
		})
		return selectedUserKeys
	}

	onSearch(searchText) {
		if (!searchText) {
			this.setState({ filteredUsers: this.state.users })
		}
		searchText = searchText.toLowerCase()
		const filteredUsers = this.state.users.filter((d) => d.FirstName.toLowerCase().includes(searchText) || d.LastName.toLowerCase().includes(searchText))
		this.setState({ filteredUsers, total: filteredUsers.length })
	}

	onLimitChange(limit) {
		this.setState({ limit, offset: 0 })
	}

	onPageClick(offset) {
		this.setState({ offset })
	}

	getUsersOnPage() {
		const users = this.state.filteredUsers
		const offset = this.state.offset
		const limit = this.state.limit
		const usersOnPage = users && users.filter((v, i) => i >= offset && i < offset + limit)
		return usersOnPage
	}

	openAddUser() {
		this.setState({ showAddUser: !this.state.showAddUser })
	}

	handleRequestCloseAddUser() {
		this.setState({
			showAddUser: false,
			selectedAutoCompleteUser: {}
		})
	}

	handleRequestSaveAddUser() {
		if (!this.state.selectedAutoCompleteUser || !this.state.selectedAutoCompleteUser.Id) {
			alert("Choose a user")
			return
		}
		this.setState({ disableButtons: true })
		const clear = () => {
			this.handleRequestCloseAddUser()
			this.getUsers()
			this.setState({ disableButtons: false })
		}
		const selectedUserId = this.state.selectedAutoCompleteUser.Id
		const hierarchyLevel = this.props.hierarchyItem
		const currentAccount = AccountStore.getCurrentAccount()
		let linkedUserIds = []
		if (hierarchyLevel.level && hierarchyLevel.level === -1) {
			linkedUserIds = currentAccount.LinkedUserIds ? currentAccount.LinkedUserIds.slice() : []
		} else {
			linkedUserIds = hierarchyLevel.LinkedUserIds ? hierarchyLevel.LinkedUserIds.slice() : []
		}

		linkedUserIds.find((x) => x === selectedUserId) || linkedUserIds.push(selectedUserId)

		if (hierarchyLevel.level && hierarchyLevel.level === -1) {
			accountActions
				.patchAccount(currentAccount.Id, {
					LinkedUserIds: linkedUserIds
				})
				.then(clear)
		} else {
			hierarchyLevel.LinkedUserIds = linkedUserIds
			accountActions.updateAccountHierarchyItem(currentAccount.Id, hierarchyLevel, true, null, clear)
		}
	}

	render() {
		const userTableHeaders = ["Name", "Default Hierarchy Item", "Default Position"]
		const { readonly } = this.props
		const users = this.getUsersOnPage()
		const { allowUsers } = this.state
		return (
			<div className="HierarchyUsers" style={{ padding: 35, position: "relative" }}>
				{this.state.showAddUser && (
					<Paper
						style={{ zIndex: "100", display: (this.state.showAddUser && "block") || "none", width: 300, position: "fixed", top: 200, right: 50, marginRight: 35 }}
						zDepth={3}
					>
						<div>
							<h3 style={{ paddingLeft: 15, marginBottom: 0 }}>Add User</h3>
							<AutoComplete
								ref={item => this.hUserAutocomplete = item}
								className="autocomplete"
								style={{
									width: "100%",
									padding: 0,
									margin: "0 20px",
									overflow: "hidden"
								}}
								floatingLabelText="User Name or External Id"
								filter={AutoComplete.caseInsensitiveFilter}
								dataSource={this.state.autoCompleteNames}
								onUpdateInput={() => this.setState({ selectedAutoCompleteUser: {} })}
								onNewRequest={selectedAutoCompleteUser => this.setState({ selectedAutoCompleteUser })}
								dataSourceConfig={{ text: "Name", value: "Id" }}
								openOnFocus
								menuStyle={{ maxHeight: window.innerHeight - 350 }}
							/>
						</div>
						<div style={{ float: "right" }}>
							<FlatButton label={strings.CANCEL} secondary onTouchTap={this.handleRequestCloseAddUser} disabled={this.state.disableButtons} />
							<FlatButton label={"ADD"} primary onTouchTap={this.handleRequestSaveAddUser} disabled={this.state.disableButtons} />
						</div>
					</Paper>
				)}
				{!readonly &&
					allowUsers && (
						<FloatingActionButton secondary className="fixed-add" style={{ top: -110, right: 20 }} onTouchTap={this.openAddUser}>
							<ContentAdd />
						</FloatingActionButton>
					)}
				{(this.state.loading && (
					<div className="spinner">
						{" "}
						<CircularProgress />
					</div>
				)) ||
					(!this.state.users.length &&
						!users.length && (
							<div style={{ textAlign: "center" }}>
								<h2>
									{(this.props.hierarchyItem.Label && strings.No + " " + this.props.hierarchyItem.Label + " " + strings.Users) ||
										strings.No + " " + strings.Users + " " + strings.For_root}
								</h2>
							</div>
						)) || (
						<div>
							<TableActionBar
								rowSelectionCount={this.state.userTableRowSelectedCount}
								singleSelectedMessage={strings.User_Selected}
								multipleSelectedMessage={strings.x_Users_Selected}
								title={null}
								onSearch={this.onSearch}
								searchText={""}
								onDeleteClick={this.onDeleteClick}
								readonly={readonly || !allowUsers}
							/>
							<Table multiSelectable={!readonly && allowUsers} selectable={!readonly && allowUsers} onRowSelection={this.rowSelection}>
								<TableHeader>
									<TableRow
										style={{
											borderBottom: "1px solid rgba(0,0,0,.7)"
										}}
									>
										{userTableHeaders.map((header, i) => {
											return <TableHeaderColumn key={`header-hierarchy-userTable-${i}`}>{header}</TableHeaderColumn>
										})}
									</TableRow>
								</TableHeader>
								<TableBody showRowHover={true} deselectOnClickaway={false}>
									{users.map((row, i) => {
										return (
											<TableRow key={row.Id} selected={this.state.selectedUserKeys.indexOf(i) !== -1}>
												<TableRowColumn style={styles.columnValue}>{row.FirstName + " " + row.LastName}</TableRowColumn>
												<TableRowColumn style={styles.columnValue}>{this.getLevelName(row.OrganizationHierarchyId)}</TableRowColumn>
												<TableRowColumn style={styles.columnValue}>{row.ExternalId}</TableRowColumn>
											</TableRow>
										)
									})}
								</TableBody>
								<TF>
									<TableFooter
										total={this.state.total}
										offset={this.state.offset}
										limit={this.state.limit}
										limitOptions={this.state.limitOptions}
										onPageClick={this.onPageClick}
										onLimitChange={this.onLimitChange}
									/>
								</TF>
							</Table>
						</div>
					)}
				{this.createDialogs()}
			</div>
		)
	}

	rowSelection(rows) {
		let result = []
		if (rows === "all") {
			for (let i = 0; i < this.state.users.length; i++) {
				result.push(i)
			}
		} else if (rows === "none") {
			result = []
		} else {
			result = rows
		}
		this.setState({
			selectedUserKeys: result,
			userTableRowSelectedCount: result.length
		}, () =>
			this.setSelectionItems(this.state.selectedUserKeys)
		)
	}

	setSelectionItems(rows) {
		if (rows === "all") {
			this.onTableRowSelected(this.state.users)
		} else if (rows === "none") {
			this.onTableRowSelected([])
		} else {
			const selectedItemsArray = new Array()
			const users = this.state.users
			rows.forEach(function (index, i) {
				selectedItemsArray.push(users[index])
			})
			this.onTableRowSelected(selectedItemsArray)
		}
	}

	onTableRowSelected(selectedUsers) {
		this.setState({ selectedUsers })
	}

	onDeleteClick() {
		const add_S_symbol = (this.state.selectedUsers.length > 1 && "S") || ""
		this.setState({
			showDeleteConfirm: true,
			deleteTitle: "UNLINK USER" + add_S_symbol + " FROM CURRENT HIERARCHY",
			deleteBody: "Are you sure you want to unlink selected User" + add_S_symbol.toLowerCase() + " from current Hierarchy Item?"
		})
	}

	onDeleteUser() {
		this.setState({ disableButtons: true })
		const self = this
		let hierarchyLevel = this.props.hierarchyItem
		const currentAccount = AccountStore.getCurrentAccount()
		if (!hierarchyLevel.Id) hierarchyLevel = currentAccount
		this.state.selectedUsers.forEach(function (user) {
			const index = hierarchyLevel.LinkedUserIds.indexOf(user.Id)
			index > -1 && hierarchyLevel.LinkedUserIds.splice(index, 1)
		})
		const clear = () => {
			this.setState({ showDeleteConfirm: false, disableButtons: false })
			self.getUsers()
		}
		hierarchyLevel === currentAccount
			? accountActions.patchAccount(currentAccount.Id, currentAccount).then(clear)
			: accountActions.updateAccountHierarchyItem(currentAccount.Id, hierarchyLevel, true, null, clear)
	}

	createDialogs() {
		return (
			<div>
				<Dialog
					title={this.state.deleteTitle}
					actions={[
						<FlatButton label={strings.Delete} primary onTouchTap={this.onDeleteUser} disabled={this.state.disableButtons} />,
						<FlatButton label={strings.Cancel} secondary onTouchTap={() => this.setState({ showDeleteConfirm: false })} disabled={this.state.disableButtons} />
					]}
					modal
					open={this.state.showDeleteConfirm}
				>
					{this.state.deleteBody}
				</Dialog>
			</div>
		)
	}
}